import { Loader2 } from "lucide-react";

// Libellés métier FR + couleurs par statut (aucun statut inventé : mappe ceux du backend).
const LABELS = {
  OPEN: "Ouverte", CLOSED: "Fermée", COMPLETED: "Terminée",
  PENDING: "En attente", ACCEPTED: "Acceptée", REFUSED: "Refusée",
  SENT: "Envoyé", DECLINED: "Refusé", PAID: "Payé",
  PENDING_PAYMENT: "En attente de paiement", DELIVERED: "Livrée",
  DISPUTED: "En litige", CANCELLED: "Annulée", REFUNDED: "Remboursée",
};
const TONE = {
  emerald: ["COMPLETED", "ACCEPTED", "PAID"],
  amber: ["PENDING", "SENT", "PENDING_PAYMENT", "OPEN"],
  violet: ["DELIVERED"],
  red: ["REFUSED", "DECLINED", "DISPUTED", "CANCELLED", "REFUNDED", "CLOSED"],
};
function toneOf(s) {
  for (const [t, arr] of Object.entries(TONE)) if (arr.includes(s)) return t;
  return "zinc";
}
const TONE_CLS = {
  emerald: "text-emerald-400 border-emerald-500/30 bg-emerald-500/10",
  amber: "text-amber-400 border-amber-500/30 bg-amber-500/10",
  violet: "text-violet-400 border-violet-500/40 bg-violet-500/10",
  red: "text-red-400 border-red-500/30 bg-red-500/10",
  zinc: "text-zinc-400 border-zinc-700 bg-zinc-800/40",
};

export function StatusBadge({ status }) {
  if (!status) return null;
  return (
    <span data-testid={`status-${status}`}
      className={`text-[11px] px-2 py-0.5 rounded-full border whitespace-nowrap ${TONE_CLS[toneOf(status)]}`}>
      {LABELS[status] || status}
    </span>
  );
}

export const money = (v, cur = "eur") =>
  v == null ? "—" : `${Number(v).toFixed(2)} ${cur === "eur" ? "€" : cur.toUpperCase()}`;

export const fmtDate = (s) => (s ? String(s).slice(0, 16).replace("T", " ") : "—");

export function ProHeader({ eyebrow, title, subtitle }) {
  return (
    <div>
      <p className="text-sm font-mono uppercase tracking-wider text-amber-500">{eyebrow}</p>
      <h1 className="font-display text-3xl sm:text-4xl font-extrabold mt-1">{title}</h1>
      {subtitle && <p className="text-zinc-500 mt-2 text-sm">{subtitle}</p>}
    </div>
  );
}

export function Loading() {
  return <div className="flex justify-center py-20"><Loader2 className="w-7 h-7 text-amber-500 animate-spin" /></div>;
}

export function Empty({ icon: Icon, title, hint, testid }) {
  return (
    <div className="bg-[#18181E] border border-zinc-800 rounded-3xl p-10 text-center" data-testid={testid}>
      {Icon && <Icon className="w-8 h-8 text-zinc-600 mx-auto mb-3" />}
      <p className="text-zinc-300 font-medium">{title}</p>
      {hint && <p className="text-sm text-zinc-500 mt-1">{hint}</p>}
    </div>
  );
}

export function ErrorState({ onRetry }) {
  return (
    <div className="bg-[#18181E] border border-red-500/20 rounded-3xl p-8 text-center" data-testid="pro-error">
      <p className="text-zinc-300">Impossible de charger ces informations.</p>
      {onRetry && <button onClick={onRetry} className="mt-3 text-sm text-amber-400">Réessayer</button>}
    </div>
  );
}
